
import { defineComponent } from 'vue';
import MenuProducts from './components/menu-products.vue';
import MenuUser from './components/menu-user.vue';
import { mapState } from 'pinia';
import { useAuthStore } from '~app/core/auth';

export default defineComponent({
  components: { MenuUser, MenuProducts },
  computed: {
    ...mapState(useAuthStore, ['isAuthenticated']),
  },
});
